<!-- <form [formGroup]="form" ngNativeValidate> -->
    <div class="modal-header">
        <h3 *ngIf="type!=='add'" class="modal-title" fxFlex="auto">{{"update_address"|translate}} : {{addressData.title}}</h3>
        <h3 *ngIf="type==='add'" class="modal-title" fxFlex="auto">{{"add_address"|translate}}</h3>
        <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.hide()"></button>
    </div>

    <div class="modal-body scroll" style="max-height: 80vh">
        <!-- <div class="form-group required">
            <label class="control-label" for="checkout-email">{{"address_title"|translate}}</label>
            <input type="text" class="form-control" [placeholder]="'address_title'|translate" formControlName="title" required>
        </div>
        <div class="row">
            <div class="form-group col-md-6 required">
                <label class="control-label" for="checkout-email">{{"name"|translate}}</label>
                <input type="text" class="form-control" [placeholder]="'name'|translate" formControlName="name" required>
            </div>
            <div class="form-group col-md-6 required">
                <label class="control-label" for="checkout-phone">{{"phone"|translate}}</label>
                <input type="text" class="form-control" [placeholder]="'phone'|translate" formControlName="phone" required>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6 required">
                <label class="control-label" for="checkout-country">{{"country"|translate}}</label>
                <select [value]="form.controls['countryId'].value" formControlName="countryId" class="form-control" (change)="onCountryChange($event)" required>
                    <option [value]="null" disabled> -- {{"select_country"|translate}} -- </option>
                    <option *ngFor="let country of countries" [value]="country._id">{{country.name[lang]}}</option>
                </select>
            </div>
            <div class="form-group col-md-6 required">
                <label class="control-label" for="checkout-street-address">{{"city"|translate}}</label>
                <select [value]="form.controls['cityId'].value" formControlName="cityId" class="form-control" (change)="onCityChange($event)" required>
                    <option [value]="null" disabled> -- {{"select_city"|translate}} -- </option>
                    <optgroup *ngFor="let area of country?.areas" [label]="area.name[lang]">
                        <option *ngFor="let city of area?.cities" [attr.data-areaId]="area._id" [value]="city._id">{{city.name[lang]}}</option>
                    </optgroup>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label class="control-label" for="checkout-postcode">{{"flat"|translate}}</label>
                <input type="text" class="form-control" formControlName="flat">
            </div>
            <div class="form-group col-md-6 required">
                <label class="control-label" for="checkout-city">{{"building"|translate}}</label>
                <input type="text" class="form-control" formControlName="building" required>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6 required">
                <label class="control-label" for="checkout-address">{{"street"|translate}}</label>
                <input type="text" class="form-control" formControlName="road" required>
            </div>
            <div class="form-group col-md-6 required">
                <label class="control-label" for="checkout-state">{{"block"|translate}}</label>
                <input type="text" class="form-control" formControlName="block" required>
            </div>
        </div> -->
      <!--   <div>
            <app-google-map [form]="form.get('location')"></app-google-map>
        </div> -->
        <app-address-form [form]="form" [addressData]="addressData"></app-address-form>
    </div>

    <div class="modal-footer">
        <button *ngIf="type!=='add'" class="btn btn-primary" (click)="updateAddress()">{{"update_address"|translate}}</button>
        <button *ngIf="type==='add'" class="btn btn-primary" (click)="addAddress()">{{"add_address"|translate}}</button>
    </div>
<!-- </form> -->
